import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { MailCheck, X } from "lucide-react";
import { toast } from "sonner";

export default function EmailVerifyBanner() {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!user || user.email_verified || dismissed) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success("Email de confirmation envoyé. Vérifie ta boîte mail (et le spam).");
    } catch (e) {
      toast.error("Trop de demandes. Réessaie dans quelques minutes.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200" data-testid="email-verify-banner">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center gap-3 text-sm">
        <MailCheck size={16} className="text-amber-700 shrink-0" />
        <p className="text-amber-900 flex-1 min-w-0">
          <strong className="font-semibold">Confirme ton email</strong> pour sécuriser ton compte et débloquer toutes les fonctionnalités.
        </p>
        <button
          onClick={resend}
          disabled={busy}
          className="text-amber-900 underline font-medium hover:text-amber-700 whitespace-nowrap disabled:opacity-50"
          data-testid="resend-verify-btn"
        >
          {busy ? "Envoi…" : "Renvoyer l'email"}
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="text-amber-700 hover:text-amber-900 shrink-0"
          aria-label="Fermer"
          data-testid="dismiss-verify-banner"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
